export enum TierLevel {
  L1 = 'L1', // Subscriber / Plot Buyer
  L2 = 'L2', // Marketing Executive
  L3 = 'L3', // Marketing Manager
  L4 = 'L4', // Assistant General Manager (AGM)
  L5 = 'L5', // General Manager (GM)
  L6 = 'L6', // Director
  ADMIN = 'ADMIN', // Corporate Operations & Governance
}

export const TIER_RANK_MAP: Record<TierLevel, number> = {
  [TierLevel.L1]: 1,
  [TierLevel.L2]: 2,
  [TierLevel.L3]: 3,
  [TierLevel.L4]: 4,
  [TierLevel.L5]: 5,
  [TierLevel.L6]: 6,
  [TierLevel.ADMIN]: 99,
};

export const TIER_LABEL_MAP: Record<TierLevel, string> = {
  [TierLevel.L1]: 'Owner',
  [TierLevel.L2]: 'Marketing Executive',
  [TierLevel.L3]: 'Marketing Manager',
  [TierLevel.L4]: 'Assistant General Manager',
  [TierLevel.L5]: 'General Manager',
  [TierLevel.L6]: 'Director',
  [TierLevel.ADMIN]: 'Administrator',
};

export const TIER_DESIGNATION_MAP: Record<TierLevel, string> = {
  [TierLevel.L1]: 'Apartment Owner',
  [TierLevel.L2]: 'Marketing Executive (ME)',
  [TierLevel.L3]: 'Marketing Manager (MM)',
  [TierLevel.L4]: 'Asst. General Manager (AGM)',
  [TierLevel.L5]: 'General Manager (GM)',
  [TierLevel.L6]: 'Director',
  [TierLevel.ADMIN]: 'Administrator',
};

export const TIER_SHORT_CODE_MAP: Record<TierLevel, string> = {
  [TierLevel.L1]: 'Owner',
  [TierLevel.L2]: 'ME',
  [TierLevel.L3]: 'MM',
  [TierLevel.L4]: 'AGM',
  [TierLevel.L5]: 'GM',
  [TierLevel.L6]: 'Director',
  [TierLevel.ADMIN]: 'Admin',
};

